<template>
  <div class="scroll-div scroll-div-device">
    <div class="chart-title col-md-12" v-if="initialCallsDone">
      <span>Number of registrations by device</span>
    </div>
    <div
      v-if="initialCallsDone"
      class="col-md-12 col-sm-12 col-xs-12 report-device-cls pl-0 xs-p-0"
    >
      <div class="col-lg-5 col-md-5 col-sm-5 col-xs-7 chart-select p-0" v-if="initialCallsDone">
        <div
          class="col-lg-2 col-md-2 col-sm-3 col-xs-10 p-0 device_sub_content"
          v-if="initialCallsDone"
        >
          <label class="sub-content">Countries</label>
        </div>
        <div
          class="col-sm-8 col-xs-12 country-filter all_customdrp_chart overflow-y-auto-reports"
          v-if="initialCallsDone"
        >
          <multiselect
            :showLabels="false"
            :close-on-select="false"
            class="multiselect-single-dropdown multiselect-multiple"
            placeholder="Country"
            label="countryName"
            track-by="countryName"
            :multiple="true"
            :searchable="true"
            :clear-on-select="false"
            :options="countryList"
            :value="selectedCountryCountList"
            @close="reRenderChart()"
          >
            <div class="selection-count" slot="selection" slot-scope="{ values, isOpen }">
              <template v-if="!isOpen && values.length == countryList.length">
                <img
                  src="/static/images/icons/filter.svg"
                  alt="filter-icon"
                  class="image-size"
                /><span class="selected-count">All</span>
              </template>
              <template v-else-if="!isOpen">
                <img
                  src="/static/images/icons/filter.svg"
                  alt="filter-icon"
                  class="image-size"
                /><span class="selected-count">{{ values.length }} Selected</span>
              </template>
              <template v-else-if="isOpen">
                <img src="/static/images/icons/filter.svg" alt="filter-icon" class="image-size" />
              </template>
            </div>
            <span slot="option" slot-scope="props">
              <div
                class="d-flex"
                @input="toggleCBValue(props.option)"
              >
                <span class="checkbox inline-checkbox">
                  <label>
                    <input
                      type="checkbox"
                      :value="props.option.countryName"
                      :checked="props.option.selected"
                    />
                    <span
                      class="cr"
                      :class="
                        props.option.countryName == 'All' && props.option.selected
                          ? 'selected-all'
                          : ''
                      "
                    ></span>
                  </label>
                </span>
                <div @click="toggleCBValue(props.option)">
                  {{ props.option.countryName }}
                </div>
              </div>
            </span>
            <span slot="noResult">No matching data</span>
          </multiselect>
        </div>
      </div>
      <div
        class="col-lg-3 col-lg-push-4 col-md-2 col-sm-2 col-sm-push-5 col-md-push-5 col-xs-5 pl-0"
        v-if="initialCallsDone && permissions.indexOf('EXPORT_DEVICES_REGISTRATIONS') > -1"
      >
        <button
          :disabled="disableDeviceChartExport"
          class="btn emergo-white-button"
          @click="exportPopup(horizontalStackedBarChartId)"
        >
          <img
            src="/static/images/icons/icon_share.svg"
            alt="share-icon"
            class="margin-btn-plus-icon"
          />
          Export
        </button>
      </div>
      <div
        class="col-lg-4 col-lg-pull-3 col-xs-12 col-sm-5 col-sm-pull-2 col-md-5 col-md-pull-2 horizontal_legend"
        id="legend2"
        v-if="initialCallsDone"
      >
        <span class="key_dot legend_active"></span>
        <span class="legend_name">Active</span>
        <span class="key_dot legend_pending"></span>
        <span class="legend_name">Pending</span>
        <span class="key_dot legend_expsoon"></span>
        <span class="legend_name">Expiring soon</span>
        <span class="key_dot legend_expired"></span>
        <span class="legend_name">Expired</span>
      </div>
    </div>
    <div id="horizontalStackedBarChartDiv" class="horizontal-stacked-bar-chart"></div>
    <loader :loadingStatus="loaderStatus"></loader>
    <registration-details-popup
      :permissions="permissions"
      :dataRow="activeRegistration"
      @hidePopup="hidePopup"
      :archivedFlag="archivedFlag"
      :reportFlag="reportFlag"
    ></registration-details-popup>
    <permission-access-modal></permission-access-modal>
    <export-popup :documentId="documentId" @resetExportPopup="resetExportPopup"></export-popup>
  </div>
</template>

<script>
import * as d3 from 'd3v4';
import FileSaver from 'file-saver';
import $ from 'jquery';
import EventBus from '../../utils/event-bus';
import Loader from '../UIComponents/Loader.vue';
import vSelect from '../UIComponents/Select.vue';
import RegistrationDetailsPopup from '../Registrations/RegistrationDetailsPopup.vue';
import PermissionAccessModal from '../Common/PermissionAccessModal.vue';
import { getCharts } from '../../apis/reports';
import { exportToPDF } from '../../apis/export';
import { getRegistrationDetailsById } from '../../apis/registrations';
import constructRegistrationObject from '../../utils/registrationDetails';
import ExportPopup from '../Common/ExportPopup.vue';

export default {
  components: {
    PermissionAccessModal,
    Loader,
    vSelect,
    RegistrationDetailsPopup,
    ExportPopup
  },
  data() {
    return {
      documentId: '',
      permissions: [],
      mode: 'reports',
      editFlag: '',
      reportFlag: true,
      activeRegistration: {},
      archivedFlag: false,
      errors: [],
      registrationdata: [],
      data: [],
      countryList: [],
      countryDropDownLabel: 'All',
      loaderStatus: false,
      countryCodeList: [],
      marginTitle: 0,
      initialCallsDone: false,
      deviceChartLoadedDuringInitialCall: true,
      horizontalStackedBarChartId: 'horizontalStackedBarChart'
    };
  },
  props: ['userRoleId'],
  computed: {
    selectedCountryCountList() {
      return this.countryList.filter((dataObj) => dataObj.selected);
    },
    disableDeviceChartExport() {
      if (this.deviceChartLoadedDuringInitialCall) {
        if (this.data.length > 0) {
          return false;
        }
      } else if (this.registrationdata.length > 0 && this.countryCodeList.length > 0) {
        return false;
      }
      return true;
    }
  },
  methods: {
    exportPopup(id) {
      this.documentId = id;
      $('#exportPdfImg').modal({
        backdrop: 'static',
        keyboard: false
      });
    },
    resetExportPopup() {
      this.documentId = '';
      $('#exportPdfImg').modal('hide');
    },
    clearNotifications() {
      this.$notify({
        clear: true,
        group: 'custom-notification'
      });
    },

    exportImage(svgId) {
      const svg = document.getElementById(svgId);
      let uri;
      saveAsSVGWithStyle(svg, {}, (svgWithStyle, width, height) => {
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        canvg(canvas, svgWithStyle, { renderCallback() {} });
        uri = canvas.toDataURL('image/png');
      });
      return uri;
    },

    exportBarChartImage() {
      this.download('RegistrationByDevice.png');
    },

    async barChartPdfExport() {
      this.loaderStatus = true;
      const deviceChartObj = {
        title: 'horizontalStackedBarChart',
        pdfTitle: 'Number of registrations by device',
        description: this.exportImage('horizontalStackedBarChart')
      };
      const response = await exportToPDF([deviceChartObj]);
      if (response) {
        this.clearNotifications();
        this.$notify({
          type: 'success',
          title: 'Success',
          text: 'PDF exported successfully!',
          group: 'custom-notification'
        });
        const blob = this.b64toBlob(response, 'application/pdf');
        FileSaver.saveAs(blob, 'RegistrationByDevice.pdf');
      } else {
        this.clearNotifications();
        this.$notify({
          type: 'error',
          title: 'Error',
          text: 'PDF export failed!',
          group: 'custom-notification'
        });
      }
      this.loaderStatus = false;
    },
    async loadHorizontalStackedBarChart() {
      this.loaderStatus = true;
      this.data = [];
      this.countryList = [{ countryName: 'All', countryCode: '-1', selected: true }];
      this.registrationdata = await getCharts();

      let productPresent = false;
      let newProductObj = {};
      let statusListParam = '';
      const statusList = ['Active', 'Pending', 'Expiring soon', 'Expired'];

      this.registrationdata.forEach((curRegistrationData) => {
        productPresent = false;
        for (let i = 0; i < this.data.length; i += 1) {
          if (curRegistrationData.product_name === this.data[i].product) {
            for (let j = 0; j < statusList.length; j += 1) {
              if (curRegistrationData.status.toLowerCase() === statusList[j].toLowerCase()) {
                this.data[i][statusList[j]] += 1;
                statusListParam = `${statusList[j].split(' ')[0].toLowerCase()}_list`;
                this.data[i][statusListParam].push({
                  code: curRegistrationData.country_code,
                  name: curRegistrationData.country_name,
                  registrationId: curRegistrationData.registration_id
                });
                break;
              }
            }
            this.data[i].totalRegistration += 1;
            productPresent = true;
            break;
          }
        }
        if (productPresent === false) {
          newProductObj = {};
          newProductObj.product = curRegistrationData.product_name;
          statusList.forEach((status) => {
            newProductObj[status] = 0;
            statusListParam = `${status.split(' ')[0].toLowerCase()}_list`;
            newProductObj[statusListParam] = [];
            if (curRegistrationData.status.toLowerCase() === status.toLowerCase()) {
              newProductObj[status] += 1;
              newProductObj[statusListParam].push({
                code: curRegistrationData.country_code,
                name: curRegistrationData.country_name,
                registrationId: curRegistrationData.registration_id
              });
            }
          });
          newProductObj.totalRegistration = 1;
          this.data.push(newProductObj);
        }
        this.prepareCountryList(curRegistrationData);
      });

      this.drawHorizontalStackedBarChart();

      this.initialCallsDone = true;
      this.deviceChartLoadedDuringInitialCall = true;
    },

    prepareCountryList(curRegistrationData) {
      let countryPresent = false;
      for (let i = 0; i < this.countryList.length; i += 1) {
        if (curRegistrationData.country_code === this.countryList[i].countryCode) {
          countryPresent = true;
          break;
        }
      }
      if (countryPresent === false) {
        this.countryList.push({
          countryName: curRegistrationData.country_name,
          countryCode: curRegistrationData.country_code,
          selected: true
        });
        this.countryCodeList.push(curRegistrationData.country_code);
      }
    },
    reRenderChart() {
      let selectedCountryCount = 0;

      this.countryCodeList = [];
      this.countryDropDownLabel = '';
      this.countryList.forEach((country) => {
        if (country.countryName === 'All' && country.selected) {
          this.countryDropDownLabel = 'All';
        } else if (country.countryName !== 'All' && country.selected) {
          this.countryCodeList.push(country.countryCode);
          selectedCountryCount += 1;
        }
      });
      if (this.countryDropDownLabel !== 'All') {
        this.countryDropDownLabel = `${selectedCountryCount} selected`;
      }

      this.deviceChartLoadedDuringInitialCall = false;
      this.filterDeviceChartData();
    },

    filterDeviceChartData() {
      let productPresent = false;
      let newProductObj = {};
      let statusListParam = '';
      this.data = [];
      const statusList = ['Active', 'Pending', 'Expiring soon', 'Expired'];

      this.registrationdata.forEach((curRegistrationData) => {
        productPresent = false;
        for (let i = 0; i < this.data.length; i += 1) {
          if (curRegistrationData.product_name === this.data[i].product) {
            for (let j = 0; j < statusList.length; j += 1) {
              if (
                curRegistrationData.status.toLowerCase() === statusList[j].toLowerCase() &&
                this.countryCodeList.indexOf(curRegistrationData.country_code) > -1
              ) {
                this.data[i][statusList[j]] += 1;
                statusListParam = `${statusList[j].split(' ')[0].toLowerCase()}_list`;
                this.data[i][statusListParam].push({
                  code: curRegistrationData.country_code,
                  name: curRegistrationData.country_name,
                  registrationId: curRegistrationData.registration_id
                });
                break;
              }
            }
            this.data[i].totalRegistration += 1;
            productPresent = true;
            break;
          }
        }
        if (
          productPresent === false &&
          this.countryCodeList.indexOf(curRegistrationData.country_code) > -1
        ) {
          newProductObj = {};
          newProductObj.product = curRegistrationData.product_name;
          statusList.forEach((status) => {
            newProductObj[status] = 0;
            statusListParam = `${status.split(' ')[0].toLowerCase()}_list`;
            newProductObj[statusListParam] = [];
            if (curRegistrationData.status.toLowerCase() === status.toLowerCase()) {
              newProductObj[status] += 1;
              newProductObj[statusListParam].push({
                code: curRegistrationData.country_code,
                name: curRegistrationData.country_name,
                registrationId: curRegistrationData.registration_id
              });
            }
          });
          newProductObj.totalRegistration = 1;
          this.data.push(newProductObj);
        }
        this.prepareCountryList(curRegistrationData);
      });

      this.drawHorizontalStackedBarChart();
    },
    toggleCBValue(option) {
      let allSelected = true;
      for (let i = 0; i < this.countryList.length; i += 1) {
        if (this.countryList[i].countryCode === option.countryCode) {
          this.countryList[i].selected = !this.countryList[i].selected;
          break;
        }
      }
      for (let i = 0; i < this.countryList.length; i += 1) {
        if (this.countryList[i].countryName !== 'All' && !this.countryList[i].selected) {
          allSelected = false;
          break;
        }
      }
      if (option.countryName === 'All') {
        for (let i = 0; i < this.countryList.length; i += 1) {
          this.countryList[i].selected = this.countryList[0].selected;
        }
      } else this.countryList[0].selected = allSelected;
    },
    drawHorizontalStackedBarChart() {
      const clientWidth = this.$el.clientWidth || 800;
      let parentWidth = clientWidth - 50;
      const actualWidth = 420;
      if (window.innerWidth < 767) {
        parentWidth = 768;
      }
      const margin = {
        top: parentWidth / 50,
        right: 20,
        bottom: 50,
        left: parentWidth / 3.3
      };
      const width = parentWidth / 1.2;
      let height = this.data.length * 35;
      this.marginTitle = (clientWidth - clientWidth / 1.5) / 2;

      const legendWidth = 220;
      const legendRectSize = 9;
      const legendSpacing = 3;

      const statusList = ['Expired', 'Expiring soon', 'Pending', 'Active'];
      const statusColor = ['#ff0606', '#ffaa49', '#4f90c3', '#013a68'];

      d3.select('.device-tooltip').html('');
      const tooltip = d3.select('.device-tooltip');
      tooltip.append('div').attr('class', 'header');
      tooltip.append('div').attr('class', 'body').style('overflow-y', 'auto');

      let statusId = '';
      statusList.forEach((status) => {
        statusId = status.split(' ')[0].toLowerCase();
        tooltip
          .select('.body')
          .append('div')
          .attr('class', 'panel list-group')
          .attr('id', `${statusId}-panel`);
      });
      d3.select('#horizontalStackedBarChartDiv svg').remove();

      const svg = d3
        .select('#horizontalStackedBarChartDiv')
        .append('svg')
        .attr('id', this.horizontalStackedBarChartId)
        .attr('width', () => {
          if (window.innerWidth < 767) {
            return actualWidth;
          }
          return width;
        })
        .attr('height', height + margin.top + margin.bottom)
        .attr('transform', 'translate(0, 0)');
      const g = svg.append('g').attr('transform', () => {
        // mobile device responsive
        if (window.innerWidth < 767) {
          return 'translate(220,50)';
        }
        return `translate(${margin.left + 80}, ${margin.top + 6})`;
      });

      const xScale = d3
        .scaleLinear()
        .rangeRound([0, width - margin.left - margin.right - legendWidth]);

      const yScale = d3.scaleBand().rangeRound([height, 0]).padding(0.5);

      const z = d3.scaleOrdinal().range(['#013a68', '#4f90c3', '#ffaa49', '#ff0606'].reverse());

      let keys = ['Active', 'Pending', 'Expiring soon', 'Expired'];
      keys = keys.reverse();
      this.data.sort((a, b) => b.totalRegistration - a.totalRegistration);
      let maxCharLength = 0;
      const xTop = d3.max(this.data, (d) => {
        if (d.product.length > maxCharLength) {
          maxCharLength = d.product.length;
        }
        return d.totalRegistration;
      });
      const xMax = xTop <= 5 ? 5 : xTop;
      xScale.domain([0, xMax]).nice();
      yScale.domain(this.data.map((d) => d.product).reverse());
      z.domain(keys);

      const xAxis = d3
        .axisBottom(xScale)
        .tickSizeInner(height)
        .ticks(5, 's')
        .tickFormat(d3.format('d'));
      const yAxis = d3.axisLeft(yScale).tickSize(0);

      g.append('g').attr('class', 'x-axis').attr('transform', 'translate(0, 0)').call(xAxis);

      g.selectAll('.tick text')
        .attr('text', (d, i) => {
          if (i === 0) {
            return ' ';
          }
          return '';
        })
        .attr('dy', -height - 10)
        .style('font-size', () => {
          // mobile device responsive
          if (window.innerWidth < 767) {
            return '10px';
          }
          return '14px';
        })
        .style('font-weight', () => {
          if (window.innerWidth < 767) {
            return 'normal';
          }
          return '500';
        })
        .attr('fill', '#2185D0');

      g.append('g')
        .attr('class', 'y-axis')
        .attr('transform', () => {
          // mobile device responsive
          if (window.innerWidth < 767) {
            return 'translate(115,0)';
          }
          if (window.innerWidth > 1024 && window.innerWidth < 1100) {
            return 'translate(-25,0)';
          }
          return 'translate(0,0)';
        })
        .call(yAxis);

      g.select('.y-axis path').remove();

      function wrap(innerText, innerwidth) {
        function addBreakSpace(inputString) {
          let string = '';
          const breakChars = ['/', '&', '-'];
          breakChars.forEach((char) => {
            // Add a space after each break char for the function to use to determine line breaks
            string = inputString.split(char).join(`${char} `);
          });
          return string;
        }
        innerText.each(function () {
          // eslint-disable-line
          const text = d3.select(this);
          let textContent = text.text();
          const tempWord = addBreakSpace(textContent).split(/\s+/);
          const y = text.attr('y');
          let tspan = text
            .text(null)
            .append('tspan')
            .attr('x', 0)
            .attr('dx', '20em')
            .attr('y', y)
            .attr('dy', '0.32em');
          function calHyphen(inputWord) {
            let customWord = inputWord;
            tspan.text(customWord);
            if (tspan.node().getComputedTextLength() > innerwidth) {
              const chars = customWord.split('');
              let asword = '';
              for (let i = 0; i < chars.length; i += 1) {
                asword += chars[i];
                tspan.text(asword);
                if (tspan.node().getComputedTextLength() > innerwidth) {
                  if (chars[i - 1] !== '-') {
                    customWord = `${customWord.slice(0, i - 1)}- ${calHyphen(
                      customWord.slice(i - 1)
                    )}`;
                  }
                  i = chars.length;
                }
              }
            }
            return customWord;
          }
          for (let i = 0; i < tempWord.length; i += 1) {
            tempWord[i] = calHyphen(tempWord[i]);
          }
          textContent = tempWord.join(' ');
          const words = textContent.split(/\s+/).reverse();
          let word = words.pop();
          let line = [];
          const lineNumber = 0;
          const lineHeight = 1.1; // ems
          let spanContent;
          const breakChars = ['/', '&', '-'];
          while (word) {
            const dy = parseFloat(tspan.attr('dy') || 0);
            line.push(word);
            tspan.text(line.join(' '));
            if (tspan.node().getComputedTextLength() > innerwidth) {
              line.pop();
              spanContent = line.join(' ');
              for (let i = 0; i < breakChars.length; i += 1) {
                // Remove spaces trailing breakChars that were added above
                spanContent = spanContent.split(`${breakChars[i]} `).join(breakChars[i]);
              }
              tspan.text(spanContent);
              line = [word];
              tspan = text
                .append('tspan')
                .attr('x', 0)
                .attr('y', y)
                .attr('dx', '20em')
                .attr('dy', `${+(lineNumber + lineHeight) + dy}em`)
                .text(word);
            }
            word = words.pop();
          }
          const emToPxRatio = parseInt(
            window.getComputedStyle(text._groups[0][0]).fontSize.slice(0, -2), // eslint-disable-line no-underscore-dangle
            10
          );
          text.attr(
            'transform',
            `translate(-${margin.left - 13}, -${(lineNumber / 2) * lineHeight * emToPxRatio})`
          );
        });
      }

      g.selectAll('.y-axis .tick text')
        .attr('dx', '0em')
        .style('font-size', () => {
          // mobile device responsive
          if (window.innerWidth < 767) {
            return '10px';
          }
          return '14px';
        })
        .style('font-weight', '500')
        .attr('fill', 'grey')
        .call(wrap, margin.left - 50);

      const stack = d3.stack().keys(keys).order(d3.stackOrderNone).offset(d3.stackOffsetNone);

      const series = stack(this.data);
      const yGap =
        series[0].length > 1
          ? yScale(series[0][1].data.product) - yScale(series[0][0].data.product)
          : 0;
      const allTextGroup = g.selectAll('.y-axis g');
      const temp = Array.from(allTextGroup._groups[0]); // eslint-disable-line no-underscore-dangle
      temp.reverse();
      const firstString = temp.length > 0 ? d3.select(temp[0]).attr('transform') : '';
      let newYTranslate = firstString
        .substring(firstString.indexOf('(') + 1, firstString.indexOf(')'))
        .split(',')[1];
      height = 0;
      const labelDimensions = [];
      temp.forEach((d) => {
        const tspanCount = d3.select(d).selectAll('text tspan').size();
        newYTranslate = Number(newYTranslate) + height;
        labelDimensions.push(newYTranslate);
        d3.select(d).attr('transform', () => {
          if (window.innerWidth < 1024) {
            // Ipad & lower versions
            return `translate(-100, ${newYTranslate})`;
          }
          if (window.innerWidth <= 1180 && window.innerWidth >= 1024) {
            // Ipad pro
            return `translate(-50, ${newYTranslate})`;
          }
          if (window.innerWidth <= 1280 && window.innerWidth > 1180) {
            return `translate(-30, ${newYTranslate})`;
          }
          if (window.innerWidth <= 1400 && window.innerWidth > 1280) {
            return `translate(0, ${newYTranslate})`;
          }
          if (window.innerWidth <= 1600 && window.innerWidth > 1400) {
            return `translate(20, ${newYTranslate})`;
          }
          if (window.innerWidth <= 2732 && window.innerWidth > 2049) {
            // 50% - 67%
            return `translate(240, ${newYTranslate})`;
          }
          if (window.innerWidth <= 2049 && window.innerWidth > 1821) {
            // 67% - 75%
            return `translate(180, ${newYTranslate})`;
          }
          if (window.innerWidth <= 1821 && window.innerWidth > 1707) {
            // 75% - 80%
            return `translate(130, ${newYTranslate})`;
          }
          if (window.innerWidth <= 1707 && window.innerWidth > 1517) {
            // 80% - 90%
            return `translate(90, ${newYTranslate})`;
          }
          return `translate(77, ${newYTranslate})`;
        });
        height = yGap + (tspanCount - 0.25) * 1.1 * 16;
      });

      g.append('g')
        .selectAll('g')
        .data(series)
        .enter()
        .append('g')
        .attr('fill', (d, i) => z(i))
        .selectAll('rect')
        .data((d) => d)
        .enter()
        .append('rect')
        .attr('class', 'bar')
        .attr('y', (d, i) => labelDimensions[i] - 8.5)
        .attr('x', (d) => xScale(d[0]))
        .attr('width', (d) => xScale(d[1]) - xScale(d[0]))
        .attr('height', yScale.bandwidth());

      g.selectAll('.bar')
        .on('mousemove', (d) => {
          tooltip.style('display', 'block');
          tooltip.style('left', `${d3.event.pageX + 10}px`);
          tooltip.style('top', `${d3.event.pageY - 50}px`);
          d3.select('.device-tooltip .header').html(`<span>${d.data.product}</span>`);

          let statusLC = '';
          let linkStr = '';

          statusList.forEach((status, index) => {
            statusLC = status.split(' ')[0].toLowerCase();
            if (d.data[`${statusLC}_list`].length > 0) {
              d3.select(`.device-tooltip #${statusLC}-panel`).html(
                `<a id="${statusLC}-group" class="list-group-item parent collapsed" data-toggle="collapse" data-target="#device-tooltip-${statusLC}"></a><div id="device-tooltip-${statusLC}" class="sublinks collapse"></div>`
              );
              d3.select(`.device-tooltip #${statusLC}-group`).html(
                `${d.data[`${statusLC}_list`].length} ${status.toLowerCase()} registrations:`
              );
              d3.select(`.device-tooltip #${statusLC}-group`).style('color', statusColor[index]);
              linkStr = '';
              d.data[`${statusLC}_list`].forEach((country) => {
                linkStr +=
                  `<div><span class="flag-icon flag-icon-squared flag-icon-${country.code.toLowerCase()} country_device_flag"></span><a class="list-group-item small" slot="${
                    country.registrationId
                  }">` +
                  `<span class="countryCustomCss-device-tooltip mt-1">${country.name}</span></a></div>`;
              });
              d3.select(`.device-tooltip .list-group #device-tooltip-${statusLC}`).html(linkStr);
            } else {
              d3.select(`.device-tooltip #${statusLC}-panel`).html('');
              d3.select(`.device-tooltip #${statusLC}-group`).html('');
              d3.select(`.device-tooltip .list-group #device-tooltip-${statusLC}`).html('');
            }
          });
        })
        .on('mouseout', () => {
          setTimeout(() => {
            tooltip.style('display', 'none');
          }, 700);
        });

      const legend = svg
        .append('g')
        .attr('class', 'legend_svg')
        .attr('font-size', 10)
        .attr('text-anchor', 'start')
        .attr('transform', () => {
          // mobile device responsive
          if (window.innerWidth < 768) {
            return 'translate(0,10)';
          }
          return `translate(${width - legendWidth + 100},${margin.top - 5})`;
        })
        .selectAll('g')
        .data(keys.reverse())
        .enter()
        .append('g')
        .attr('transform', (d, i) => {
          let widthVal = i === 3 ? 55 : 0;
          widthVal = i === 2 ? 10 : widthVal;
          if (window.innerWidth < 768) {
            return `translate(${i * 60 + widthVal}, 0)`;
          }
          return `translate(0,${i * 20})`;
        });

      legend
        .append('rect')
        .attr('width', legendRectSize)
        .attr('height', legendRectSize)
        .attr('fill', z);

      legend
        .append('text')
        .style('font-size', () => {
          // mobile device responsive
          if (window.innerWidth < 767) {
            return '12px';
          }
          return '14px';
        })
        .style('font-weight', () => {
          // mobile device responsive
          if (window.innerWidth < 767) {
            return '300';
          }
          return '500';
        })
        .attr('fill', '#2185D0')
        .attr('x', legendRectSize + legendSpacing + 4)
        .attr('y', legendRectSize - legendSpacing + 4)
        .text((d) => d);

      this.loaderStatus = false;
      const glist = document.getElementsByClassName('y-axis')[0].children;
      const transform =
        glist.length > 0 ? glist[0].attributes.transform.nodeValue : 'translate(0, 0)';
      let addToYAxisHeight = 0;
      if (maxCharLength < 150) {
        addToYAxisHeight = 150;
      } else if (window.innerWidth <= 1250 && window.innerWidth >= 1024) {
        addToYAxisHeight = 900;
      } else {
        addToYAxisHeight = 270;
      }
      const transy = Math.round(transform.split(', ')[1].split(')')[0]) + addToYAxisHeight;
      svg.attr('height', transy);

      svg.select('.x-axis').selectAll('.tick line').attr('y2', transy);

      svg.select('.y-axis').selectAll('.tick line').remove(); // y axis line element not required so it is removed.

      g.selectAll('.tick line').attr('stroke', 'lightgrey').attr('stroke-opacity', 0.7);
      g.select('.x-axis path').remove();
    },

    viewRegistration(record) {
      this.activeRegistration = record;
      this.activeId = record.registrationId;
      $('#registrationDetail').modal();
    },

    async callRegistration(value) {
      if (this.permissions.indexOf('REG_TRACKER_RECORDS') === -1) {
        $('#permissionAccessModal').modal({
          backdrop: 'static',
          keyboard: false
        });
      } else {
        if (this.userRoleId === 4) {
          return;
        }
        this.chartLoaderStatus = true;
        const row = await getRegistrationDetailsById(value);
        this.chartLoaderStatus = false;
        if (row && row.error) {
          this.$notify({
            clear: true,
            group: 'custom-notification'
          });
          this.$notify({
            type: 'error',
            title: 'Error',
            text: 'Registration is not found!',
            group: 'custom-notification'
          });
        } else if (row) {
          const entry = constructRegistrationObject(row);
          this.viewRegistration(entry);
        }
      }
    },
    closeModal(e) {
      if (this.editFlag) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }
      this.activeId = '';
    },
    hidePopup(value) {
      this.editFlag = value;
    }
  },
  created() {
    socket.on(`alertGetChartsEvent_${localStorage.getItem('userId')}`, (data) => {
      this.importPercentage = data;
    });
    if (this.$route.params.reportPermissions) {
      this.permissions = this.$route.params.reportPermissions;
    }
  },
  mounted() {
    this.loadHorizontalStackedBarChart();
    d3.select('body').append('div').attr('class', 'device-tooltip').style('display', 'none');
    $('.device-tooltip').on('click', '.small', (event) => {
      this.callRegistration(event.currentTarget.getAttribute('slot'));
    });

    $('#registrationDetail').on('hide.bs.modal', this.closeModal);
    EventBus.$on('permissionsDeviceList', (permissionsList) => {
      this.permissions = permissionsList;
    });
    window.addEventListener('resize', this.drawHorizontalStackedBarChart);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.drawHorizontalStackedBarChart);
    socket.removeAllListeners(`alertGetChartsEvent_${localStorage.getItem('userId')}`);
    $('.device-tooltip').remove();
    EventBus.$off('permissionsDeviceList');
  }
};
</script>
<style lang="scss" scoped>
.emergo-white-button {
  padding: 5px 15px;
}
@media (min-width: 1025px) {
  .country-filter {
    ::v-deep {
      .v-select {
        .dropdown-toggle {
          border-radius: 4px !important;
        }
      }
    }
  }
}
@media (max-width: 1024px) {
  .country-filter {
    ::v-deep {
      .v-select {
        .dropdown-toggle {
          border: 0.5px solid $primary;
        }
      }
    }
  }
}
@media (min-width: 768px) and (max-width: 1024px) {
  .country-filter {
    ::v-deep {
      .v-select {
        .dropdown-toggle {
          width: 150px;
        }
        .open-indicator {
          left: 125px;
        }
      }
    }
  }
}

@media (max-width: 320px) {
  .country-filter {
    ::v-deep {
      .v-select {
        .dropdown-toggle {
          width: 150px;
        }
        .open-indicator {
          left: 125px;
        }
      }
    }
    .multiselect-single-dropdown {
      &.multiselect-multiple {
        width: 108%;
      }
    }
  }
}

@media (max-width: 767px) {
  .xs-p-0 {
    padding: 0;
    .country-filter {
      padding-left: 0px;
    }
  }
}
@media screen and (min-width: 400px) and (max-width: 480px) {
  .key_dot {
    margin-right: 0.45em;
  }
}
</style>
